import React, { ChangeEvent } from 'react';
import { Checkbox } from 'common/components';
import { GridApi } from 'ag-grid-community/dist/lib/gridApi';
import {
    AccessActions,
    FeatureActions
} from 'modules/admin-roles-management/enums/admin-role.enum';
import './FeaturesCheckboxCellRenderer.scss';

export function FeaturesCheckbox({
    data,
    onAction,
    api,
    isActionDisabled = false,
    actionName,
    rowIndex
}: {
    data: any;
    onAction: (
        value: boolean,
        data: any,
        action: FeatureActions,
        api: GridApi,
        rowIndex: number,
        actionName: AccessActions
    ) => void;
    isActionDisabled: boolean;
    api: GridApi;
    actionName: AccessActions;
    rowIndex: number;
}) {
    return (
        <div className="checkbox-align">
            <Checkbox
                id={'toggleId' + actionName + data.applicationFeatureId}
                checked={actionName === AccessActions.READ ? data.readAccess : data.writeAccess}
                disabled={isActionDisabled}
                name={actionName + data.applicationFeatureId}
                indeterminate={data?.indeterminate ?? false}
                value={'toggleId' + actionName + data.applicationFeatureId}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    if (isActionDisabled) {
                        return null;
                    } else {
                        return onAction(
                            event.target.checked,
                            data,
                            FeatureActions.CHECK_UNCHECK,
                            api,
                            rowIndex,
                            actionName
                        );
                    }
                }}
            />
        </div>
    );
}
